module.exports = __webpack_public_path__ + "static/media/document_Description.9bdcf02a.svg";